import { EventbriteReconnectButton } from './EventbriteReconnectButton';
export const EventbriteReconnectionConfig = {
  reconnectButton: EventbriteReconnectButton
};